import type { SVGProps } from 'react'

type IconName =
  | 'arrow'
  | 'chip'
  | 'cloud'
  | 'cube'
  | 'network'
  | 'tool'
  | 'factory'
  | 'code'
  | 'sun'
  | 'moon'
  | 'menu'
  | 'close'
  | 'mail'
  | 'github'
  | 'linkedin'
const paths: Record<IconName, string> = {
  arrow: 'M4 12h16m-6-6 6 6-6 6',
  chip: 'M6 6h12v12H6zM9 9h6v6H9zM9 2v4m6-4v4M9 18v4m6-4v4M2 9h4m-4 6h4m12-6h4m-4 6h4',
  cloud: 'M7 18h11a4 4 0 0 0 1-7.87 6 6 0 0 0-11.6-2A5 5 0 0 0 7 18Z',
  cube: 'm12 2 9 5v10l-9 5-9-5V7l9-5Zm0 10 9-5M3 7l9 5m0 0v10',
  network: 'M12 8v4m0 0H5v4m7-4h7v4M9 2h6v6H9zM2 16h6v6H2zM16 16h6v6h-6z',
  tool: 'm14 6 4 4m-9 4-6 6a2 2 0 0 1-3-3l6-6m2-6a6 6 0 0 0 8 8l5-5-4 1-3-3 1-4-5 5Z',
  factory: 'M3 21V7h4v7l7-5v5l7-5v12H3Zm5-4v1m5-1v1m5-1v1M4 3h2',
  code: 'm8 5-7 7 7 7m8-14 7 7-7 7M14 3l-4 18',
  sun: 'M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1 1m12 12 1 1M5 19l1-1M18 6l1-1M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
  moon: 'M20 15A9 9 0 0 1 9 4a9 9 0 1 0 11 11Z',
  menu: 'M3 6h18M3 12h18M3 18h18',
  close: 'm6 6 12 12M6 18 18 6',
  mail: 'M3 5h18v14H3zM3 6l9 7 9-7',
  github:
    'M9 19c-4 1-4-2-6-2m13 5v-4c0-1-.3-2-1-2 4-.5 6-2 6-6 0-2-.5-3-1.5-4 .5-1 .5-3-.2-4-2 0-3 1-4 1-2-.5-4-.5-6 0-1 0-2-1-4-1-.7 1-.7 3-.2 4C4 7 3.5 8 3.5 10c0 4 2 5.5 6 6-.7.5-1 1-1 2v4',
  linkedin: 'M4 9v12M4 3v1M9 21V9h5v2c3-4 7-1 7 3v7m-7 0v-7',
}
export function PortfolioIcon({
  name,
  ...props
}: SVGProps<SVGSVGElement> & { name: IconName }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d={paths[name]} />
    </svg>
  )
}
